<template lang="pug">
  section.section
    b-field(v-if="acceptingOrderItems.length == 0")
      b-upload(v-model="dropFile" @input="input" drag-drop id="csv-upload" :loading="loading")
        section(class="section")
          div(class="content has-text-centered")
            p
              b-icon(pack="fas" custom-class="fa-2x fa-file-csv")
            p
              | CSVファイルをドラッグしてください

    b-field(v-if="acceptingOrderItems.length > 0")
      .columns
        .column
          button(@click="submit" class="button is-danger" :disable="enableSubmitButton == false" id="submit-button")
            i.fa.fa-plus.fa-fw
            | 更新
        .column.is-one-fifth
          .tag.is-rounded.is-light.is-medium.is-pulled-right
            | 横スクロール
            i.fas.fa-fw.fa-arrow-right
    b-field
      .scroll-table
        b-table(
          :data="acceptingOrderItems"
          :loading="loading"
          narrowed
          hoverable
          striped
          paginated
          per-page="100"
          )
          template(slot-scope="props")
            b-table-column(field="i" label="No." width="40" sortable)
              b-field {{ props.row.i }}
            b-table-column(field="id" label="ID" width="50" sortable)
              b-field {{ props.row.sid }}
            b-table-column(field="isbn" label="ISBN13" width="200")
              | {{ props.row.isbn }}
            b-table-column(field="isbn" label="書籍名" width="400")
              | {{ bookName(props.row.isbn) }}
            b-table-column(field="agency_shop_code" label="取次書店コード" width="110")
              | {{ props.row.agency_shop_code }}
            b-table-column(field="shop_name" label="書店名"  width="300")
              | {{ props.row.book_shop_name }}
            b-table-column(field="bansen" label="番線" width="50")
              | {{ props.row.bansen }}
            b-table-column(field="agency_code" label="帳合" width="100")
              | {{ agencyName(props.row.agency_code) }}
            b-table-column(field="order_route_id" label="受注経路" width="100")
              | {{ orderRouteName(props.row.order_route_id) }}
            b-table-column(field="deliver_type_id" label="出荷属性" width="150")
              deliver-type-id-input(
                :doValidate="true"
                v-model="props.row.deliver_type_id"
                input_name="出荷属性"
                :deliver_types="deliver_types"
                immediate
              )
            b-table-column(field="sales_person_id" label="営業担当" width="100")
              | {{ salesPersonName(props.row.sales_person_id) }}
            b-table-column(field="kyakutyu_memo" label="客注メモ" width="200")
              b-input(
                v-model="props.row.kyakutyu_memo"
                data-vv-as="客注メモ"
              )
            b-table-column(field="bibo" label="備忘" width="200")
              b-input(
                v-model="props.row.bibo"
                data-vv-as="備忘"
              )
            b-table-column(field="accepting_date" label="受注日" width="100")
              | {{ props.row.accepting_date | moment("YYYY/MM/DD") }}
            b-table-column(field="accepting_order_number" label="発注数" width="80")
              ValidationProvider(
                :rules="`required|min_value:${props.row.manipulated_number}`"
                v-slot="{ errors }"
                name="発注数"
                :ref="'order_number' + `${props.row.i}`"
                immediate
              )
                b-field(:type="{'is-danger': errors.length > 0 }"
                      :message="errors[0]")
                  b-input(
                    :data-vv-name="'order_number' + props.row.i"
                    data-vv-as="発注数"
                    type="number"
                    size="is-small"
                    v-model="props.row.order_number"
                  )
            b-table-column(field="delivered_number" label="配本済数" width="80")
              | {{ props.row.manipulated_number }}
            b-table-column(field="delivered_number" label="残数" width="50")
              | {{ props.row.order_number - props.row.manipulated_number }}
    b-field(v-if="acceptingOrderItems.length > 0")
      button(@click="submit" class="button is-danger" :disable="enableSubmitButton == false")
        i.fa.fa-plus.fa-fw
        | 更新
</template>

<script>
  import Papa from 'papaparse'
  import AcceptingOrderItem from 'models/accepting_order_item'
  import ManipulatedOrderItem from 'models/manipulated_order_item'
  import CacheDispatcher from 'mixins/cache_dispatcher'
  import { ValidationProvider } from 'vee-validate'
  import DeliverTypeIdInput from 'inputs/deliver_type_id_input'

  export default {
    name: 'multiple-accepting-order-items-field',
    mixins: [CacheDispatcher],
    components: {
      ValidationProvider,
      DeliverTypeIdInput
      },
    data() {
      return {
        loading: false,
        dropFile: null,
        acceptingOrderItems: [],
      }
    },
    computed: {
      books(){  return this.$store.getters['Books/records'] },
      accepting_order_routes(){ return this.$store.getters['AcceptingOrderRoutes/records'] },
      agencies(){ return this.$store.getters['Agencies/records'] },
      final_book_shop_agencies(){ return this.$store.getters['FinalBookShopAgencies/records'] },
      final_book_shops(){ return this.$store.getters['FinalBookShops/records'] },
      shop_people(){ return this.$store.getters['ShopPeople/records'] },
      deliver_types(){ return this.$store.getters['DeliverTypes/records'] },
      sales_people(){ return this.$store.getters['SalesPeople/records'] },
      enableSubmitButton(){
        return this.acceptingOrderItems.length != 0
      },
    },
    methods: {
      bookName(value){
        if (!value) return ''
        const book = this.books.find(book => book.isbn == value)
        return book ? book.name : ''
      },
      shopName(agency_code, agency_shop_code){
        if (!agency_code) return ''
        const tmp = this.final_book_shop_agencies
            .find(final_book_shop_agency => final_book_shop_agency.agency_code == agency_code && final_book_shop_agency.agency_shop_code == agency_shop_code)
        if(!tmp) return ''
        const shop_code = tmp.shop_code
        const final_book_shop = this.final_book_shops.find(final_book_shop => final_book_shop.shop_code == shop_code)
        return final_book_shop ? final_book_shop.name : ''
      },
      agencyName(agency_code){
        if (!agency_code) return ''
        const agency = this.agencies.find(agency => agency.code == agency_code)
        return agency ? agency.name : ''
      },
      orderRouteName(id){
        if (!id) return ''
        const orderRoute = this.accepting_order_routes.find(route => route.id == id)
        return orderRoute ? orderRoute.name : ''
      },
      deliverTypeName(id){
        if (!id) return ''
        const deliverType = this.deliver_types.find(type => type.id == id)
        return deliverType ? deliverType.name : ''
      },
      salesPersonName(id){
        if (!id) return ''
        const salesPerson = this.sales_people.find(type => type.id == id)
        return salesPerson ? salesPerson.name : ''
      },
      async fetchAcceptingOrderItems(data){
        const records = data.filter((record) => /^[-]?([1-9]\d*|0)(\.\d+)?$/.test(record[0]))
        const ids = records.map((record) => {  return record[0] })

        const params = {
          page: 1,
          per_page: 9999999,
          q: {
            id_in: ids,
            only_uncompleted: true
          }
        }

        this.loading = true
        try{
          const res = await this.$http.post('/api/v1/accepting_order_items/search', params)
          const data = res.data
          if(data.accepting_order_items.length == 0) {
            this.acceptingOrderItems = []
            this.total = 0
            this.loading = false
            this.$toast.open({
              message: '不正なデータが入力されました。',
              type: 'is-danger',
              position: 'is-bottom'
            })
            return
          }

          this.acceptingOrderItems = []
          let currentTotal = data.total_results
          if (data.total_results / this.perPage > 1000) {
            currentTotal = this.perPage * 1000
          }
          this.total = currentTotal

          let recordsObj = {}
          records.forEach(record => { recordsObj[Number(record[0])] = record }) // acceptingOrderItemのidをキーとしたobj
          data.accepting_order_items.forEach((item) => {
            const recordFromCsv = recordsObj[item.id]
            item.kyakutyu_memo = recordFromCsv[10]
            item.deliver_type_id = this.deliverTypeId(recordFromCsv[12])
            item.bibo = recordFromCsv[14]
            item.order_number = recordFromCsv[17]
            const acceptingOrderItem = new AcceptingOrderItem(item)
            this.acceptingOrderItems.push(acceptingOrderItem)
          })
          this.loading = false
        }catch (error) {
          const {
            status,
            statusText
          } = error.response;
          this.acceptingOrderItems = []
          this.total = 0
          this.loading = false
          this.$toast.open({
            message: 'データの取得に失敗しました。',
            type: 'is-danger',
            position: 'is-bottom'
          })
          throw error
        }
      },
      input(file){
        Papa.parse(file, {
          complete: (results) => {
            this.fetchAcceptingOrderItems(results.data)
          }
        });
      },
      deliverTypeId(deliver_type_name) {
        const deliver_type = this.deliver_types.find(type => type.name == deliver_type_name)
        return deliver_type ? deliver_type.id : null
      },
      has_errors() {
        return document.querySelector("input.is-danger")
      },
      submitRequest() {
        const method = 'put'
        const url = `/api/v1/multiple_accepting_order_items.json`
        const params = {
          multiple_accepting_order_item: {
            accepting_order_items_attributes: this.acceptingOrderItems
          }
        }
        return this.$http({ method: method, url: url, data: params })
      },
      async submit(){
        if(this.has_errors()) {
          this.$toast.open({
            message: '入力に誤りがあります。',
            type: 'is-danger',
            position: 'is-bottom'
          })
          return
        }
        this.loading = true
        try {
          const { data } = await this.submitRequest()
          this.loading = false
          this.$toast.open({
            message: '更新に成功しました。',
            type: 'is-danger',
            position: 'is-bottom'
          })
          window.location.href = "/users/accepting_order_items"
        } catch (e) {
          this.loading = false
          this.$toast.open({
            message: '更新に失敗しました。',
            type: 'is-danger',
            position: 'is-bottom'
          })
          throw e
        }
      },
    },
    created() {
      this.dispatch_with_cache('Agencies/fetch', 'agencies', this.agencies)
      this.$store.dispatch('Books/fetch', 'books')
      this.dispatch_with_cache('AcceptingOrderRoutes/fetch', 'accepting_order_routes', this.accepting_order_routes)
      this.$store.dispatch('DeliverTypes/fetch', 'deliver_types')
      this.dispatch_with_cache('SalesPeople/fetch', 'sales_people', this.sales_people)
    }
  }
</script>